const isAnswered = (answer) => {
  return (
    (answer.a_string !== "" &&
      answer.a_string !== null &&
      answer.a_string !== undefined &&
      !["object", "array"].includes(typeof answer.a_string)) ||
    (typeof answer.a_string === "array" && answer.a_string.length > 0) ||
    (typeof answer.a_string === "object" &&
      answer.a_string !== null &&
      // ether this obj has keys
      (Object.keys(answer.a_string).length > 0 ||
        // or it is a date
        (answer.a_string instanceof Date && !isNaN(answer.a_string))))
  );
};

export default isAnswered;
